<template>
  <div class="main-404">
    <div class="container">
      <h2>Page not found</h2>
      <h3><router-link to="/home" class="rl">Go home</router-link></h3>
    </div>
  </div>
  
</template>

<script>
    export default {
        name: "v404Page",

    }
</script>


<style scoped>

.main-404 {
  width: 100%;
  height: 100vh;
  position: relative;
}

.main-404 .container {
  position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center
}

.main-404::before {
  content: ' ';
  display: block;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100vh;
  opacity: 0.3;
  background-color: black;
  background-image: url('../assets/bg404.png');
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  z-index: -1;

}


.main-404 .rl {
      color: inherit;
      text-decoration: none;

      background:
      linear-gradient(
            to right,
            #a10b0b,
            #730202
      ),
      linear-gradient(
            to right,
            rgba(255, 0, 0, 1),
            rgba(255, 0, 180, 1),
            rgba(0, 100, 200, 1)
      );
      background-size: 100% 2px, 0 2px;
      background-position: 100% 100%, 0 100%;
      background-repeat: no-repeat;
      transition: background-size 400ms;
}

.main-404 .rl:hover {
      background-size: 0 2px, 100% 2px;
}




</style>